export const PendingApprovalsTabRoute = {
  path: '/PendingApprovalsTab',
  load: () => import('./PendingApprovalsTab'),
  protected: true,
};
